<template>
    <!-- frontend 仅承载顾客访问的 App/H5 展示页面。 -->
    <a-config-provider :locale="locale">
        <router-view/>
    </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

export default {
    name: 'App',
    data() {
        return {locale: zhCN};
    }
};
</script>
